import {
  FastWeigh_Connection_Read,
  FastWeigh_Connection_Test_Read,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class FastWeighConnection {
  constructor(
    private _id: string,
    private _company_id: string,
    private _api_key_last_four: string | null,
    private _api_key_verified_at: Dayjs | null,
    private _connected: boolean,
    private _enabled: boolean,
    private _project_push_enabled: boolean,
    private _order_push_enabled: boolean,
    private _ticket_pull_enabled: boolean,
    private _push_after: Dayjs | null,
    private _tickets_synchronized_at: Dayjs | null,
    private _region_name: string | null,
    private _external_tenant_id: string | null,
    private _last_error_at: Dayjs | null,
    private _last_error_message: string | null,
  ) {}

  public get id() {
    return this._id;
  }

  public get companyId() {
    return this._company_id;
  }

  public get apiKeyLastFour() {
    return this._api_key_last_four;
  }

  public get apiKeyVerifiedAt() {
    return this._api_key_verified_at;
  }

  public get connected() {
    return this._connected;
  }

  public get enabled() {
    return this._enabled;
  }

  public get projectPushEnabled() {
    return this._project_push_enabled;
  }

  public get orderPushEnabled() {
    return this._order_push_enabled;
  }

  public get ticketPullEnabled() {
    return this._ticket_pull_enabled;
  }

  public get pushAfter() {
    return this._push_after;
  }

  public get ticketsSynchronizedAt() {
    return this._tickets_synchronized_at;
  }

  public get regionName() {
    return this._region_name;
  }

  public get externalTenantId() {
    return this._external_tenant_id;
  }

  public get lastErrorAt() {
    return this._last_error_at;
  }

  public get lastErrorMessage() {
    return this._last_error_message;
  }

  public static parse(proto: FastWeigh_Connection_Read) {
    return new FastWeighConnection(
      proto.id,
      proto.company_id,
      proto.api_key_last_four ?? null,
      proto.api_key_verified_at ? dayjs(proto.api_key_verified_at) : null,
      proto.connected,
      proto.enabled,
      proto.project_push_enabled,
      proto.order_push_enabled,
      proto.ticket_pull_enabled,
      proto.push_after ? dayjs(proto.push_after) : null,
      proto.tickets_synchronized_at ? dayjs(proto.tickets_synchronized_at) : null,
      proto.region_name ?? null,
      proto.external_tenant_id ?? null,
      proto.last_error_at ? dayjs(proto.last_error_at) : null,
      proto.last_error_message ?? null,
    );
  }
}

export class FastWeighConnectionTest {
  constructor(
    private _connection: FastWeighConnection,
    private _write_permission: boolean | null,
  ) {}

  public get connection() {
    return this._connection;
  }

  public get writePermission() {
    return this._write_permission;
  }

  public static parse(proto: FastWeigh_Connection_Test_Read) {
    return new FastWeighConnectionTest(
      FastWeighConnection.parse(proto),
      proto.write_permission ?? null,
    );
  }
}
